var urlCart = Shopify.routes.root + 'cart'

function fetchCartSection(){
  fetch(urlCart)
  .then(function(response) {
    return response.text()
  })
  .then(function(text) {
    var drawerInner = document.querySelector(".drawer__inner")
    if (!!drawerInner && !!text) {
      getProgressBars(text, drawerInner)
    }
  })
}

function getProgressBars(text, element){
  if (!!element) {
    var apendedProgressSection = element.querySelector(".progress-bars-section");
    var parser = new DOMParser();
    var htmlDocument = parser.parseFromString(text, "text/html");
    var progressSection = htmlDocument.documentElement.querySelector(".progress-bars-section");
    
    if(!!!apendedProgressSection){
      if (!!progressSection) {
        element.prepend(progressSection);
      }
    } else {
      if (!!progressSection) {
        element.replaceChild(progressSection, apendedProgressSection)
      }  
    }
  }
}

document.addEventListener('drawerOpen', function() {
  fetchCartSection()
});
document.addEventListener("cart:updated", function () {
  fetchCartSection();
});